import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { SettingsStyles } from '../../../../styles/CommonStyles';
import { useSelector } from '../../../utils';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const MOBILE_SECTION_TEST_ID = 'mobile-setting-section';
export const MOBILE_SNAPSHOTS_CHECKBOX_TEST_ID = 'allow-mobile-snapshots-checkbox';
export const MOBILE_BIOMETRICS_CHECKBOX_TEST_ID = 'allow-mobile-biometrics-checkbox';

export type MobileSectionProps = SiteSettingsForSiteAdminProps<'sheetImageEnabled' | 'mobileBiometricsEnabled'>;

export function MobileSection() {
  const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
  const isSessionServerAdmin = useSelector(SessionUserSelectors.isSessionServerAdmin);

  return (
    <SettingsSection
      title={getTitle(isOnlineEnvironment)}
      description={Messages.mobileSheetImageDetails()}
      testId={MOBILE_SECTION_TEST_ID}
    >
      <div className={SettingsStyles.checkboxGroup}>
        <FormikCheckbox
          name='settings.sheetImageEnabled'
          label={Messages.createOfflineSnapShots()}
          testId={MOBILE_SNAPSHOTS_CHECKBOX_TEST_ID}
        />
      </div>
      {FeatureFlags.showMobileBiometricsSetting && isSessionServerAdmin &&
        <>
          <div className={SettingsStyles.settingsGroupDescription}>
            {Messages.biometricsMobileDetails()}
          </div>
          <div className={SettingsStyles.checkboxGroup}>
            <FormikCheckbox
              name='settings.mobileBiometricsEnabled'
              label={Messages.enableBiometricsMobile()}
              testId={MOBILE_BIOMETRICS_CHECKBOX_TEST_ID}
            />
          </div>
        </>
      }
    </SettingsSection>
  );
}

function getTitle(isOnlineEnvironment: boolean) {
  return isOnlineEnvironment
    ? Messages.settings_mobile_title_online()
    : Messages.settings_mobile_title_server();
}

/* for registering the component in settings registry */
export const MobileSectionSpecs = componentRegistryEntry({
  name: 'MobileSection',
  component: MobileSection
});
